import PropTypes from "prop-types";
import { Card } from "react-bootstrap";
import { useAuth } from "../context/AuthContext";

const ReportHeadComponent = ({ formName }) => {
  const { user } = useAuth();

  return (
    <>
      <Card.Img
        className="w-auto mb-1"
        src={`${process.env.REACT_APP_STORAGE_URL}/company-logo/${user.Com_Logo}`}
        alt="Logo Icon"
      />
      <Card.Title className="mb-1 fs-1 fw-normal text-uppercase text-truncate">
        {user.ReportHead_TH} <br /> {formName}
      </Card.Title>
    </>
  );
};

ReportHeadComponent.propTypes = {
  formName: PropTypes.string
};

export default ReportHeadComponent;
